export default {
    data() {
        return {
            swiperInstances: {},
            defaultSwiperOptions: {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: false,
                // on: {
                //     reachEnd() {
                //         this.slideTo(0);
                //     },
                // },
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false,
                },
                pagination: false,
                navigation: false,
                breakpoints: {
                    320: { slidesPerView: 1 },
                    425: { slidesPerView: 2 },
                    640: { slidesPerView: 3 },
                    768: { slidesPerView: 4 },
                    1024: { slidesPerView: 6 },
                },
            },
        };
    },
    methods: {
        onSwiperReady(refName, swiper) {
            console.log('Swiper Ready');
            this.$set(this.swiperInstances, refName, swiper);
        },
        pauseAutoplay(refName) {
            console.log('pause Autoplay Ready');
            const instance = this.swiperInstances[refName];
            if (instance?.autoplay?.running) {
                instance.autoplay.stop();
            }
        },
        resumeAutoplay(refName) {
            console.log('resume Autoplay Ready');
            const instance = this.swiperInstances[refName];
            if (instance?.autoplay && !instance.autoplay.running) {
                instance.autoplay.start();
            }
        },
    },
};
